"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));
var _TableBody = _interopRequireDefault(require("@material-ui/core/TableBody"));
var _TableCell = _interopRequireDefault(require("@material-ui/core/TableCell"));
var _TableRow = _interopRequireDefault(require("@material-ui/core/TableRow"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-unused-vars */

/* eslint-enable no-unused-vars */

class MTableBody extends React.Component {
  renderEmpty(emptyRowCount, renderData) {
    const rowHeight = this.props.options.padding === "default" ? 49 : 36;
    const localization = (0, _objectSpread2.default)({}, MTableBody.defaultProps.localization, this.props.localization);
    if (this.props.options.showEmptyDataSourceMessage && renderData.length === 0) {
      let addColumn = 0;
      if (this.props.options.selection) {
        addColumn++;
      }
      if (this.props.actions && this.props.actions.filter(a => a.position === "row" || typeof a === "function").length > 0) {
        addColumn++;
      }
      if (this.props.hasDetailPanel) {
        addColumn++;
      }
      if (this.props.isTreeData) {
        addColumn++;
      }
      return /*#__PURE__*/React.createElement(_TableRow.default, {
        style: {
          height: rowHeight * (this.props.options.paging && this.props.options.emptyRowsWhenPaging ? this.props.pageSize : 1)
        },
        key: "empty-" + 0
      }, /*#__PURE__*/React.createElement(_TableCell.default, {
        style: {
          paddingTop: 0,
          paddingBottom: 0,
          textAlign: "center"
        },
        colSpan: this.props.columns.reduce((currentVal, columnDef) => columnDef.hidden ? currentVal : currentVal + 1, addColumn),
        key: "empty-"
      }, localization.emptyDataSourceMessage));
    } else if (this.props.options.emptyRowsWhenPaging) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, [...Array(emptyRowCount)].map((r, index) => /*#__PURE__*/React.createElement(_TableRow.default, {
        style: {
          height: rowHeight
        },
        key: "empty-" + index
      })), emptyRowCount > 0 && /*#__PURE__*/React.createElement(_TableRow.default, {
        style: {
          height: 1
        },
        key: "empty-last1"
      }));
    }
  }
  renderUngroupedRows(renderData) {
    return renderData.map((data, index) => {
      if (data.tableData.editing || this.props.bulkEditOpen) {
        return /*#__PURE__*/React.createElement(this.props.components.EditRow, {
          columns: this.props.columns.filter(columnDef => {
            return !columnDef.hidden;
          }),
          components: this.props.components,
          data: data,
          errorState: this.props.errorState,
          icons: this.props.icons,
          localization: (0, _objectSpread2.default)({}, MTableBody.defaultProps.localization.editRow, this.props.localization.editRow, {
            dateTimePickerLocalization: this.props.localization.dateTimePickerLocalization
          }),
          key: "row-" + data.tableData.id,
          mode: this.props.bulkEditOpen ? "bulk" : data.tableData.editing,
          options: this.props.options,
          isTreeData: this.props.isTreeData,
          detailPanel: this.props.detailPanel,
          onEditingCanceled: this.props.onEditingCanceled,
          onEditingApproved: this.props.onEditingApproved,
          getFieldValue: this.props.getFieldValue,
          onBulkEditRowChanged: this.props.onBulkEditRowChanged,
          scrollWidth: this.props.scrollWidth
        });
      } else {
        return /*#__PURE__*/React.createElement(this.props.components.Row, {
          components: this.props.components,
          icons: this.props.icons,
          data: data,
          index: index,
          errorState: this.props.errorState,
          key: "row-" + data.tableData.id,
          level: 0,
          options: this.props.options,
          localization: (0, _objectSpread2.default)({}, MTableBody.defaultProps.localization.editRow, this.props.localization.editRow, {
            dateTimePickerLocalization: this.props.localization.dateTimePickerLocalization
          }),
          onRowSelected: this.props.onRowSelected,
          actions: this.props.actions,
          columns: this.props.columns,
          getFieldValue: this.props.getFieldValue,
          detailPanel: this.props.detailPanel,
          path: [index + this.props.pageSize * this.props.currentPage],
          onToggleDetailPanel: this.props.onToggleDetailPanel,
          onRowClick: this.props.onRowClick,
          isTreeData: this.props.isTreeData,
          onTreeExpandChanged: this.props.onTreeExpandChanged,
          onEditingCanceled: this.props.onEditingCanceled,
          onEditingApproved: this.props.onEditingApproved,
          hasAnyEditingRow: this.props.hasAnyEditingRow,
          treeDataMaxLevel: this.props.treeDataMaxLevel,
          cellEditable: this.props.cellEditable,
          onCellEditStarted: this.props.onCellEditStarted,
          onCellEditFinished: this.props.onCellEditFinished,
          scrollWidth: this.props.scrollWidth
        });
      }
    });
  }
  renderGroupedRows(groups, renderData) {
    return renderData.map((groupData, index) => /*#__PURE__*/React.createElement(this.props.components.GroupRow, {
      actions: this.props.actions,
      key: groupData.value == null ? "" + index : groupData.value,
      columns: this.props.columns,
      components: this.props.components,
      detailPanel: this.props.detailPanel,
      getFieldValue: this.props.getFieldValue,
      groupData: groupData,
      groups: groups,
      icons: this.props.icons,
      level: 0,
      path: [index + this.props.pageSize * this.props.currentPage],
      onGroupExpandChanged: this.props.onGroupExpandChanged,
      onRowSelected: this.props.onRowSelected,
      onRowClick: this.props.onRowClick,
      onEditingCanceled: this.props.onEditingCanceled,
      onEditingApproved: this.props.onEditingApproved,
      onToggleDetailPanel: this.props.onToggleDetailPanel,
      onTreeExpandChanged: this.props.onTreeExpandChanged,
      options: this.props.options,
      isTreeData: this.props.isTreeData,
      hasAnyEditingRow: this.props.hasAnyEditingRow,
      localization: (0, _objectSpread2.default)({}, MTableBody.defaultProps.localization.editRow, this.props.localization.editRow, {
        dateTimePickerLocalization: this.props.localization.dateTimePickerLocalization
      }),
      cellEditable: this.props.cellEditable,
      onCellEditStarted: this.props.onCellEditStarted,
      onCellEditFinished: this.props.onCellEditFinished,
      onBulkEditRowChanged: this.props.onBulkEditRowChanged,
      scrollWidth: this.props.scrollWidth
    }));
  }
  render() {
    let renderData = this.props.renderData;
    const groups = this.props.columns.filter(col => col.tableData.groupOrder > -1).sort((col1, col2) => col1.tableData.groupOrder - col2.tableData.groupOrder);
    let emptyRowCount = 0;
    if (this.props.options.paging) {
      emptyRowCount = this.props.pageSize - renderData.length;
    }
    return /*#__PURE__*/React.createElement(_TableBody.default, null, this.props.options.filtering && /*#__PURE__*/React.createElement(this.props.components.FilterRow, {
      columns: this.props.columns.filter(columnDef => !columnDef.hidden),
      icons: this.props.icons,
      hasActions: this.props.actions.filter(a => a.position === "row" || typeof a === "function").length > 0,
      actionsColumnIndex: this.props.options.actionsColumnIndex,
      onFilterChanged: this.props.onFilterChanged,
      selection: this.props.options.selection,
      localization: (0, _objectSpread2.default)({}, MTableBody.defaultProps.localization.filterRow, this.props.localization.filterRow, {
        dateTimePickerLocalization: this.props.localization.dateTimePickerLocalization
      }),
      hasDetailPanel: !!this.props.detailPanel,
      detailPanelColumnAlignment: this.props.options.detailPanelColumnAlignment,
      isTreeData: this.props.isTreeData,
      filterCellStyle: this.props.options.filterCellStyle,
      filterRowStyle: this.props.options.filterRowStyle,
      hideFilterIcons: this.props.options.hideFilterIcons,
      scrollWidth: this.props.scrollWidth
    }), this.props.showAddRow && this.props.options.addRowPosition === "first" && /*#__PURE__*/React.createElement(this.props.components.EditRow, {
      columns: this.props.columns.filter(columnDef => {
        return !columnDef.hidden;
      }),
      data: this.props.initialFormData,
      components: this.props.components,
      errorState: this.props.errorState,
      icons: this.props.icons,
      key: "key-add-row",
      mode: "add",
      localization: (0, _objectSpread2.default)({}, MTableBody.defaultProps.localization.editRow, this.props.localization.editRow, {
        dateTimePickerLocalization: this.props.localization.dateTimePickerLocalization
      }),
      options: this.props.options,
      isTreeData: this.props.isTreeData,
      detailPanel: this.props.detailPanel,
      onEditingCanceled: this.props.onEditingCanceled,
      onEditingApproved: this.props.onEditingApproved,
      getFieldValue: this.props.getFieldValue,
      scrollWidth: this.props.scrollWidth
    }), groups.length > 0 ? this.renderGroupedRows(groups, renderData) : this.renderUngroupedRows(renderData), this.props.showAddRow && this.props.options.addRowPosition === "last" && /*#__PURE__*/React.createElement(this.props.components.EditRow, {
      columns: this.props.columns.filter(columnDef => {
        return !columnDef.hidden;
      }),
      data: this.props.initialFormData,
      components: this.props.components,
      errorState: this.props.errorState,
      icons: this.props.icons,
      key: "key-add-row",
      mode: "add",
      localization: (0, _objectSpread2.default)({}, MTableBody.defaultProps.localization.editRow, this.props.localization.editRow, {
        dateTimePickerLocalization: this.props.localization.dateTimePickerLocalization
      }),
      options: this.props.options,
      isTreeData: this.props.isTreeData,
      detailPanel: this.props.detailPanel,
      onEditingCanceled: this.props.onEditingCanceled,
      onEditingApproved: this.props.onEditingApproved,
      getFieldValue: this.props.getFieldValue,
      scrollWidth: this.props.scrollWidth
    }), this.renderEmpty(emptyRowCount, renderData));
  }
}
MTableBody.defaultProps = {
  actions: [],
  currentPage: 0,
  pageSize: 5,
  renderData: [],
  selection: false,
  localization: {
    emptyDataSourceMessage: "No records to display",
    filterRow: {},
    editRow: {}
  }
};
MTableBody.propTypes = {
  actions: _propTypes.default.array,
  components: _propTypes.default.object.isRequired,
  columns: _propTypes.default.array.isRequired,
  currentPage: _propTypes.default.number,
  detailPanel: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]))]),
  getFieldValue: _propTypes.default.func.isRequired,
  hasAnyEditingRow: _propTypes.default.bool,
  hasDetailPanel: _propTypes.default.bool.isRequired,
  icons: _propTypes.default.object.isRequired,
  isTreeData: _propTypes.default.bool.isRequired,
  onRowSelected: _propTypes.default.func,
  options: _propTypes.default.object.isRequired,
  pageSize: _propTypes.default.number,
  renderData: _propTypes.default.array,
  initialFormData: _propTypes.default.object,
  selection: _propTypes.default.bool.isRequired,
  scrollWidth: _propTypes.default.number.isRequired,
  showAddRow: _propTypes.default.bool,
  treeDataMaxLevel: _propTypes.default.number,
  localization: _propTypes.default.object,
  onFilterChanged: _propTypes.default.func,
  onGroupExpandChanged: _propTypes.default.func,
  onToggleDetailPanel: _propTypes.default.func.isRequired,
  onTreeExpandChanged: _propTypes.default.func.isRequired,
  onRowClick: _propTypes.default.func,
  onEditingCanceled: _propTypes.default.func,
  onEditingApproved: _propTypes.default.func,
  errorState: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.bool]),
  cellEditable: _propTypes.default.object,
  onCellEditStarted: _propTypes.default.func,
  onCellEditFinished: _propTypes.default.func,
  bulkEditOpen: _propTypes.default.bool,
  onBulkEditRowChanged: _propTypes.default.func
};
var _default = exports.default = MTableBody;